<template>
  <div>
    <div class="wrap">
      <!-- 自定义导航栏 -->
      <Nav></Nav>
      <!-- 自定义导航栏 -->
      <!-- 登录 -->
      <!--登录-->
      <div class="login-wrap">
        <!-- <img class="login-back-img" src="~@/assets/img/home_poster.png" alt=""> -->
        <div class="login-box">
          <div class="login-margin">
            <el-row>
              <el-col :span="20">
                <div class="login-action" v-if="!$store.getters.isLogin">
                  <div class="login-padding">
                    <div class="login-title">登录</div>
                    <div class="input-wrap" :style="errorInfo.mobileWrapObj">
                      <img src="~@/assets/img/login_btn_user.png" alt="">
                      <input type="text" placeholder="请输入手机号" v-model.trim="nickname" @blur="checkNickname">
                      <img v-show="nickname" src="~@/assets/img/login_btn_cancel.png" alt=""
                           @click="clear('nickname')">
                      <div class="input-tip" :style="errorInfo.mobileTipObj">
                        <Icon type="md-alert" size="18" color="#D63036" />
                        <span class="tip-content">{{errorInfo.mobileTip}}</span>
                      </div>
                    </div>
                    <div class="input-wrap last" :style="errorInfo.passwordWrapObj">
                      <img src="~@/assets/img/login_btn_password.png" alt="">
                      <input type="password" placeholder="请输入密码" v-model.trim="password" @input="checkPassword">
                      <img v-show="password" src="~@/assets/img/login_btn_cancel.png" alt=""
                           @click="clear('password')">
                      <div class="input-tip" :style="errorInfo.passwordTipObj">
                        <Icon type="md-alert" size="18" color="#D63036" />
                        <span class="tip-content">{{ errorInfo.passwordTip }}</span>
                      </div>
                    </div>
                    <div class="operate-wrap">
                      <div class="forget-pwd" @click="toForgetPwd">忘记密码？</div>
                      <div class="to-register" @click="toRegister">注册账号</div>
                    </div>
                    <div class="to-login" @click="doLogin">登录</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 登录 -->
      <Footer :is-kfc-foot="true"></Footer>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/Nav.vue'
  import Footer from '@/components/Footer.vue'
  import { Icon } from 'view-design'
  import { getToken } from '@/utils/auth'
  import { login } from '@/api/user'
  export default {
    name: 'Home',
    components: {
      Nav,
      Footer,
      Icon
    },
    data() {
      return {
        nickname: '',
        password: '',
        code: '',
        isLogin: getToken() ? true : false, //是否登录
        loading: false,
        errorInfo: {
          mobileTip: '',
          passwordTip: '',
          mobileTipObj: {
            display: 'none'
          },
          passwordTipObj: {
            display: 'none'
          },
          mobileWrapObj: {
            border: '1px solid #eeeeee'
          },
          passwordWrapObj: {
            border: '1px solid #eeeeee' // ff4f76
          }
        }
      }
    },
    computed: {
    },
    mounted: function() {

    },
    methods: {
      //清除文本框
      clear(val) {
        this[val] = ''
      },
      //监听密码
      checkPassword() {
        var isValidate = true
        var tip = ''
        if (this.password === '') {
          tip = '请填写密码'
          isValidate = false
          return this.handelErrorTip(isValidate, 1, tip)
        }
        if (!(this.password.length >= 6)) {
          tip = '密码长度错误'
          isValidate = false
          return this.handelErrorTip(isValidate, 1, tip)
        }
        tip = ''
        isValidate = true
        return this.handelErrorTip(isValidate, 1, tip)
      },
      //监听昵称或手机号
      checkNickname() {
        var isValidate = true
        var tip = ''
        if (this.nickname === '') {
          tip = '请填写手机号'
          isValidate = false
          return this.handelErrorTip(isValidate, 0, tip)
        }
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.nickname))) {
          tip = '手机号格式错误'
          isValidate = false
          return this.handelErrorTip(isValidate, 0, tip)
        }
        isValidate = true
        tip = ''
        return this.handelErrorTip(isValidate, 0, tip)
      },
      handelErrorTip: function(isValidate, type, tip) {
        if (type == 0) {
          if (isValidate === false) {
            this.errorInfo.mobileTip = tip
            this.errorInfo.mobileTipObj.display = 'flex'
            this.errorInfo.mobileWrapObj.border = '1px solid #D63036'
          } else {
            this.errorInfo.mobileTip = ''
            this.errorInfo.mobileTipObj.display = 'none'
            this.errorInfo.mobileWrapObj.border = '1px solid #eee'
          }
        } else {
          if (isValidate === false) {
            this.errorInfo.passwordTip = tip
            this.errorInfo.passwordTipObj.display = 'flex'
            this.errorInfo.passwordWrapObj.border = '1px solid #D63036'
          } else {
            this.errorInfo.passwordTip = ''
            this.errorInfo.passwordTipObj.display = 'none'
            this.errorInfo.passwordWrapObj.border = '1px solid #eee'
          }
        }
        return isValidate
      },
      //跳转到登录界面
      toRegister() {
        this.$router.push('/pc/register?redirect=/pc/kfc/home')
      },
      toForgetPwd() {
        this.$router.push('/pc/resetPwd?redirect=/pc/kfc/home')
      },
      doLogin() {
        var isValidate = this.allValidate()
        if (isValidate === false) {
          return
        }
        this.loading = true
        var loginFormData = {
          mobile: this.nickname,
          password: this.password
        }

        this.$store.dispatch('user/login', loginFormData).then((response) => {
          this.loading = false
          this.isLogin = true
          this.nickname = this.password = ''
          this.$Message.success('登录成功')
          this.$router.push("/pc/kfc/statistics")
        }).catch(() => {
          this.loading = false
        })
      },
      allValidate() {
        return (this.checkNickname() && this.checkPassword())
      },
    }
  }
</script>

<style lang="less" scoped>
  .fixed-wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrap {
    min-width: 850px;
    /* 登录*/
    .login-wrap {
      min-height: 660px;
      background-image: url(../../../../assets/img/kfc/login_bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      position: relative;
      .login-box {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      .login-action {
        background: #ffffff;
        width: 380px;
        height: 380px;
        float: right;
        .login-padding {
          padding: 30px 60px;
        }
        .login-title {
          font-family: Alibaba-PuHuiTi-M;
          font-size: 32px;
          color: #222222;
          line-height: 80px;
          text-align: center;
        }
        .input-wrap {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 5px 10px;
          background: #ffffff;
          border: 1px solid #eeeeee;
          border-radius: 2px;
          margin-top: 20px;
          margin-bottom: 25px;
          position: relative;;
          img {
            cursor: pointer;
            width: 24px;
            height: 24px;
          }
          input {
            width: 90%;
            font-size: 14px;
            color: #222222;
            padding: 5px;
            border: none;
          }
          .input-tip {
            position: absolute;
            top: 45px;
            left: 0;
            font-size: 12px;
            color: #D63036;
            letter-spacing: 0;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            &.hidden {
              display: none;
            }
            .tip-content {
              margin-left: 3px;
              color: #D63036;
            }
          }
        }
      }
    }
    ::-webkit-input-placeholder {
      font-family: Alibaba-PuHuiTi-R;
      font-size: 14px;
      color: #c1c1c1;
      letter-spacing: 0;
    }

    .operate-wrap {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      margin-top: 16px;
      width: 100%;
      overflow: hidden;
      .forget-pwd {
        float: left;
        cursor: pointer;
      }
      .to-register {
        float: right;
        cursor: pointer;
      }
    }
    .to-login {
      color: #ffffff;
      background: #D63036;
      border-radius: 2px;
      margin-top: 20px;
      text-align: center;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
    }
    /* 登录*/
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/home/Index.vue